import { lazy } from 'react';

const list = lazy(() => import('pages/schedulePickup/List'));

export { list };
